import React, { useState, useEffect } from 'react';
import { Grid, makeStyles, createStyles, Theme as AugmentedTheme } from '@material-ui/core';

interface IProps {
    bannerLink: string | null,
}

const useStyles = makeStyles((theme: AugmentedTheme) => createStyles({
    blockHolder: {
        width: 'fit-content',
        border: '1px solid #dadce0',
        height: 'fit-content',
        margin: '12px 0',
        overflow: 'hidden',
        borderRadius: 8,
    },
    blockHolder1: {
        width: '100%',
        objectFit: 'contain',
    },
}))

export default function Banner({ bannerLink }: IProps) {
    const classes = useStyles();

    const [bannerUrl, setBannerUrl] = useState<string>('');

    useEffect(() => {
        bannerLink && setBannerUrl(bannerLink);
    }, [bannerLink])

    return (bannerUrl.length ? 
            <Grid container direction="column" alignItems="center" className={classes.blockHolder}>
            <img alt='' className={classes.blockHolder1} src={bannerUrl} />
            </Grid> 
            : null
           )
}
